module.exports = __webpack_public_path__ + "img/SEJ_Eventos_agregar sección.13b62784.svg";